import { Injectable } from '@angular/core';
import {DialogConfig, DialogContentType, DialogService as FdDialogService} from '@fundamental-ngx/core/dialog';
import { MessageBoxRef, MessageBoxService, MessageBoxType } from '@fundamental-ngx/core';
import { ServiceModule } from '../../../service.module';

export class DialogPosition {
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
}

@Injectable({ providedIn: ServiceModule })
export class DialogService {
    constructor(private dialogService: FdDialogService, private _messageBoxService: MessageBoxService) {}

    open(component: DialogContentType, dialogConfig: DialogConfig) {
        return this.dialogService.open(component, dialogConfig);
    }


    openDialog(component: DialogContentType, data: any, height?: string, width?: string, position?: DialogPosition) {
        let dialogConfig = {
            data: data,
            height: height || "auto",
            width: width || "auto",
            backdropClass: 'dialog-backdrop',
            dialogPanelClass: "workspace-dialog",
            responsivePadding: true,
            focusTrapped: true,
            position: position
        };
        return this.open(component, dialogConfig);
    }

    openSideDialog(component: DialogContentType, data: any, width?: string, escKeyCloseable = true) {
        return this.open(component, {
            data: data,
            width: width || '62.5rem',
            height: 'calc(150vh - 20px)',
            responsivePadding: true,
            focusTrapped: true,
            backdropClass: 'dialog-backdrop',
            dialogPanelClass: "workspace-dialog",
            position: {top: '20px', left: '0' , right: '0'},
            escKeyCloseable: escKeyCloseable
        });
    }

    openMessageBox(title: string, content: string, type: MessageBoxType, width?: string): MessageBoxRef {
        const messageBoxRef: MessageBoxRef = this._messageBoxService.open(
            {
                title: title,
                content: content,
                cancelButton: 'OK',
                cancelButtonCallback: () => messageBoxRef.close('Cancel'),
            },
            {
                type: type,
                showSemanticIcon: true,
                ariaLabelledBy: 'fd-message-box-semantic-types-header fd-message-box-semantic-types-body',
                ariaDescribedBy: 'fd-message-box-semantic-types-types',
                width: width
            }
        );
        return messageBoxRef;
    }
}
